var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"id":"wc-popup-error","title":""},on:{"ok":_vm.ok}},[[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }